import { paths } from '@mc/paths'
import {
  EventTypes,
  Locations,
  NavigationEvents,
  trackGoldStandardEvent,
  track,
  getPageSource,
} from '@mc/track-event'

type NavLevel =
  (typeof NavigationEvents.LEVELS)[keyof typeof NavigationEvents.LEVELS]

type NavLocation = (typeof Locations)[keyof typeof Locations]

export const trackNavClick =
  (
    action: string,
    level: NavLevel = NavigationEvents.LEVELS.PRIMARY,
    location: NavLocation = Locations.NAVIGATION,
  ) =>
  () => {
    const pageSource = getPageSource()

    trackGoldStandardEvent(NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
      action,
      level,
      location,
      page_source: pageSource,
    })
  }

const trackGiftPurchaseClick = () => {
  track(EventTypes.PURCHASE_CLICK, {
    page_source: 'Navigation',
    location: 'navigation',
    level: NavigationEvents.LEVELS.SECONDARY,
    href: paths.checkoutGift(),
    action: 'Gift MasterClass',
    content_type: 'product',
    // content_ids: 304,
    class: 'annual-pass',
  })
}

export const trackGiftCTAClick = (
  level: NavLevel = NavigationEvents.LEVELS.SECONDARY,
) => {
  trackNavClick('Gift MasterClass', level)()
  trackGiftPurchaseClick()
}

const trackViewPlansNavClick = (level: NavLevel) => {
  trackGoldStandardEvent(NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
    category: 'home-nav-header',
    action: 'View Plans',
    level,
    page_source: getPageSource(),
  })
}

const trackViewPlansPurchaseClick = (level: NavLevel) => {
  track(EventTypes.PURCHASE_CLICK, {
    page_source: getPageSource(),
    location: 'navigation',
    level,
    href: paths.checkout,
    action: 'View Plans',
  })
}

export const trackPlansClick = (level: NavLevel) => () => {
  trackViewPlansNavClick(level)
  trackViewPlansPurchaseClick(level)
}

export const trackLoginClick = () => {
  trackNavClick('Log In', NavigationEvents.LEVELS.PRIMARY)()
}

export const trackLogoClick = () => {
  trackNavClick('MC Logo', NavigationEvents.LEVELS.PRIMARY)()
}
